import { useQuery } from "@tanstack/react-query";
import { getSpecifyRelatedResourceList } from "../api/admin";
import { useCookieData } from '../hook/useCookieData';

export const useFetchPrivilege = () => {
    const { userId } = useCookieData();
    return useQuery(
        ["fetchAuthInfo"],
        () =>
            getSpecifyRelatedResourceList({
                userId: userId,
                resourceType: "",
                app: "",
                module: "",
                subModule: "",
                parentId: null,
            }),
        {
            retry: false,
            refetchOnWindowFocus: false,
            select: (response) => {
                const resData = response?.data;
                if (!resData) {
                    return null;
                }
                return {
                    ...response,
                };
            },
        }
    );
};

